/**
 * @fileoverview Input/output schemas for chapter-splitter-v2.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { ChapterIdeaSchema } from '@/domains/chapter-workspace/schemas';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.chapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.chapterContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.charactersCurrent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  chapters: z.array(ChapterIdeaSchema).length(2).describe('An array of exactly two new chapter ideas, representing the split content.'),
  contents: z.array(z.string()).length(2).describe("An array of two HTML strings, representing the prose content for each of the two new chapters."),
  explanation: z.string().describe("A brief explanation of how the breaking point to the two new chapters was determined.")
});

export type Output = z.infer<typeof OutputSchema>;
